import { render, staticRenderFns } from "./IntegralGoods.vue?vue&type=template&id=a1c92a6e&scoped=true"
import script from "./IntegralGoods.vue?vue&type=script&lang=js"
export * from "./IntegralGoods.vue?vue&type=script&lang=js"
import style0 from "./IntegralGoods.vue?vue&type=style&index=0&id=a1c92a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c92a6e",
  null
  
)

export default component.exports